import i18n from '@/i18n';
import { formatDateAdaptive } from '@/infrastructure/utils/digit';
import { formatDate } from '@/infrastructure/utils/timestamp';
import { Option } from '@/proto/field';
import { MetricSubType } from '@/proto/metric';


export enum SortType  {
  DESC='DESC'
}

export enum ReportOrEvent{
  ReportTime='event_time',
  EventTime='report_time'
}

export const TIME_LIST = [ReportOrEvent.ReportTime, ReportOrEvent.EventTime];

const DATE_FORMAT = 'YYYY/MM/DD HH:mm:ss';

export const ALARM_TYPE = [
  { value: 0, label: i18n.t('wake_up唤醒') },
  { value: 1, label: i18n.t('alarm唤醒') },
  { value: 2, label: i18n.t('wake_up唤醒') },
  { value: 3, label: i18n.t('alarm唤醒') },
];

export enum ElementEnum {
  Alarm = 'alarm',
  WakeLock = 'wake_lock',
  Location = 'location',
}

export const  batteryFactor: Record<string, any> = {
  alarm: {
    text: 'Alarm',
    unitStr: i18n.t('唤醒次数'),
    options: [
      {
        label: i18n.t('上报时间'),
        value: ReportOrEvent.ReportTime,
        sorter: {
          sortField: 'event_time',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDate(text, DATE_FORMAT),
      },
      {
        label: i18n.t('发生时间'),
        value: ReportOrEvent.EventTime,
        sorter: {
          sortField: 'report_time',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDate(text, DATE_FORMAT),
      },
      {
        label: i18n.t('周期累计wake_up唤醒次数'),
        value: 'wakeup_frequency',
        sorter: {
          sortField: 'wakeup_frequency',
          sortType: SortType.DESC,
        },
      },
      {
        label: i18n.t('周期累计alarm唤醒次数'),
        value: 'frequency',
        sorter: {
          sortField: 'frequency',
          sortType: SortType.DESC,
        },
      },
    ],
  },
  wake_lock: {
    text: 'WakeLock',
    unitStr: i18n.t('持有时长'),
    options: [
      {
        label: i18n.t('上报时间'),
        value: ReportOrEvent.ReportTime,
        sorter: {
          sortField: 'event_time',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDate(text, DATE_FORMAT),
      },
      {
        label: i18n.t('发生时间'),
        value: ReportOrEvent.EventTime,
        sorter: {
          sortField: 'report_time',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDate(text, DATE_FORMAT),
      },
      {
        label: i18n.t('单次持有最大时长'),
        value: 'single_max_duration_in_ms',
        sorter: {
          sortField: 'single_max_duration_in_ms',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDateAdaptive(text),
      },
      {
        label: i18n.t('周期累计持有次数'),
        value: 'frequency',
        sorter: {
          sortField: 'frequency',
          sortType: SortType.DESC,
        },
      },
      {
        label: i18n.t('周期累计持有时长'),
        value: 'duration_in_ms',
        sorter: {
          sortField: 'duration_in_ms',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDateAdaptive(text),
      },
    ],
  },
  location: {
    text: i18n.t('定位'),
    unitStr: i18n.t('定位时长'),
    options: [
      {
        label: i18n.t('上报时间'),
        value: ReportOrEvent.ReportTime,
        sorter: {
          sortField: 'event_time',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDate(text, DATE_FORMAT),
      },
      {
        label: i18n.t('发生时间'),
        value: ReportOrEvent.EventTime,
        sorter: {
          sortField: 'report_time',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDate(text, DATE_FORMAT),
      },
      {
        label: i18n.t('单次定位最大时长'),
        value: 'single_max_duration_in_ms',
        sorter: {
          sortField: 'single_max_duration_in_ms',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDateAdaptive(text),
      },
      {
        label: i18n.t('周期累计定位次数'),
        value: 'frequency',
        sorter: {
          sortField: 'frequency',
          sortType: SortType.DESC,
        },
      },
      {
        label: i18n.t('周期累计定位时长'),
        value: 'duration_in_ms',
        sorter: {
          sortField: 'duration_in_ms',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDateAdaptive(text),
      },
    ],
  },
};

export const SUB_METRIC_OPTIONS = [
  { label: i18n.t('异常次数'), value: MetricSubType.SUB_TYPE_COUNT },
  { label: i18n.t('次数样本量'), value: MetricSubType.SUB_TYPE_DAU_COUNT },
  { label: i18n.t('异常设备数'), value: MetricSubType.SUB_TYPE_DEVICE_UV },
  { label: i18n.t('设备样本量'), value: MetricSubType.SUB_TYPE_DAU_DEVICE_UV },
];
export const DIMENSION_OPTIONS = [
  { label: i18n.t('APP版本'), value: 'app_version', color: '#3385FF' },
  { label: i18n.t('机型'), value: 'model', color: '#52B7FF' },
  { label: i18n.t('系统版本'), value: 'os_version', color: '#60DBB4' },
  { label: 'Bundle ID', value: 'bundle_id', color: '#3385FF' },
  { label: i18n.t('进程'), value: 'process_name', color: '#52B7FF' },
  { label: i18n.t('厂商'), value: 'brand', color: '#60DBB4' },
  { label: i18n.t('异常类型'), value: 'exception_type', color: '#3385FF', renderField: (field: string): string => EXCEPTION_TYPE_OPTION.find(item => item.value === field)?.label || field },
];


export const EXCEPTION_TYPE_OPTION: Option[] = [
  {
    label: i18n.t('单次定位时长超阈值'),
    value: 'single_location_duration_exceed',
  },
  {
    label: i18n.t('周期累计定位次数超阈值'),
    value: 'sum_location_frequency_exceed',
  },
  {
    label: i18n.t('周期累计定位时长超阈值'),
    value: 'sum_location_duration_exceed',
  },
  {
    label: i18n.t('单次持有Wake Lock时长超阈值'),
    value: 'single_wake_lock_duration_exceed',
  },
  {
    label: i18n.t('周期累计持有Wake Lock次数超阈值'),
    value: 'sum_wake_lock_frequency_exceed',
  },
  {
    label: i18n.t('周期累计持有Wake Lock时长超阈值'),
    value: 'sum_wake_lock_duration_exceed',
  },
  {
    label: i18n.t('周期累计wake_up类型Alarm唤醒次数超阈值'),
    value: 'sum_wakeup_alarm_frequency_exceed',
  },
  {
    label: i18n.t('周期累计Alarm唤醒次数超阈值'),
    value: 'sum_alarm_frequency_exceed',
  },
];


